<footer class="tm-footer-wrapper">
    <span class="footer-decoration"></span>
    <div class="container">
        <div class="tm-footer">
            <div class="footer-content">
                <div class="row justify-content-center">
                    <div class="col-md-5 text-center">
                        <div class="footer-logo">
                            <span class="svg-icon cursor-pointer" [svgIcon]="'logoMain'" (click)="goToHome()"></span>
                        </div>
                        <p class="footer-desc mx-auto" *ngIf="footer">{{footer.description}}</p>
                        @if(contactInfo){<ul class="footer-social">
                            @if(contactInfo.twitterLink){<li>
                                <a  [href]="contactInfo.twitterLink" target="_blank" class="btn tm-btn btn-transparent">
                                    <span class="svg-icon" [svgIcon]="'circleX'"></span>
                                </a>
                            </li>}

                            @if(contactInfo.facebookLink){<li>
                                <a  [href]="contactInfo.facebookLink" target="_blank"  class="btn tm-btn btn-transparent">
                                    <span class="svg-icon" [svgIcon]="'circleFacebook'"></span>
                                </a>
                            </li>}
                            @if(contactInfo.snapchatLink){<li>
                                <a  [href]="contactInfo.snapchatLink" target="_blank"  class="btn tm-btn btn-transparent">
                                    <span class="svg-icon" [svgIcon]="'circleSnap'"></span>
                                </a>
                            </li>}
                            @if(contactInfo.youtubeLink){<li>
                                <a  [href]="contactInfo.youtubeLink" target="_blank"  class="btn tm-btn btn-transparent">
                                    <span class="svg-icon" [svgIcon]="'circleYoutube'"></span>
                                </a>
                            </li>}
                            @if(contactInfo.linkedInLink){<li>
                                <a  [href]="contactInfo.linkedInLink" target="_blank"  class="btn tm-btn btn-transparent">
                                    <span class="svg-icon" [svgIcon]="'circleLinkedin'"></span>
                                </a>
                            </li>}
                        </ul>}
                    </div>
                </div>
            </div>
            <div class="footer-copyrights">
                <p>
                    {{ 'FOOTER.RIGHTS' | translate }}
                    <a href=""> &#64; {{ 'FOOTER.PLATFORM_NAME' | translate }}</a>
                </p>
                <ul class="copyrights-links">
                    <li>
                        <a (click)="goToTermsofUse(1)">{{ 'FOOTER.TERMS' | translate }}</a>
                    </li>
                    <li>
                        <a (click)="goToPrivacyPolicy(2)">{{ 'FOOTER.PRIVACY' | translate }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</footer>